// Same as the default for tables
export const PAGE_SIZE = 12;

export const getPageBoundaries = (currentPage: number, itemCount = 0) => {
  const firstEntry = Math.min(currentPage * PAGE_SIZE, itemCount - 1);
  const lastEntry = Math.min((currentPage + 1) * PAGE_SIZE - 1, itemCount - 1);

  return [firstEntry, lastEntry];
};
